/**
 * Write
 */

import Config from '../Config';
import Util from '../Util';
import Site from '../Site';
import DropdownLayer from '../DropdownLayer';
import DropdownLayer2Depth from '../DropdownLayer2Depth';
import ParamInfo from './ParamInfo';
import GameInfo from '../GameInfo';
import Svg from '../Svg';
import Tag from './Tag';
import Dialog from '../Dialog';

class Write {
  public onLoaded: any;

  private $node: any;

  private removeButtonName: string = `fe-remove-button`;

  private editor: any;

  private dropdownBoardList: any;

  private dropdownLayer: any;

  private isSubmit: boolean = false;

  private isReload: boolean = false;

  private isCancel: boolean = false;

  private updateData: any = {};

  private articleId: string;

  private categoryId: number = 0;

  private boardType: number;

  private aliasName: string;

  private permissionList: any = [];

  private paramInfo: ParamInfo;

  private dialog: Dialog;

  private tag: any;

  private isDialogFlag: boolean = false;

  constructor($node: any, options: any) {
    const win = window as any;

    this.$node = $node;
    this.$node.addClass(Config.COMMUNITY_NODE);

    // loadedComplete
    this.onLoaded = new Util.Observer();
    this.onLoaded.add(() => {
      this.editor.onAppendContent();
    });

    this.articleId = Util.getParams().articleId;

    jQuery.extend(true, Config, options);

    Config.board = options.board ? options.board : Config.board;
    Config.isVote = options.isVote ? options.isVote : Config.isVote;
    Config.isServerBoard = options.isServerBoard ? options.isServerBoard : Config.isServerBoard;
    Config.isImage = options.isImage ? options.isImage : Config.isImage;
    Config.isEmoticon = options.isEmoticon ? options.isEmoticon : Config.isEmoticon;
    Config.onHookSubmitBefore = options.onHookSubmitBefore ? options.onHookSubmitBefore : '';
    Config.isShowWriteCategory = options.isShowWriteCategory ? options.isShowWriteCategory : Config.isShowWriteCategory;
    Config.isTag = options.isTag ? options.isTag : Config.isTag;

    // Config.allowOnBeforeUnloadAlert
    this.$node.append(this.template());

    // create Editor
    this.editor = new win.ui.RWDEditor(jQuery('#froala-editor'), Config.board !== 'all' ? Config.board : Config.site === 'lineage2' ? 'l2free' : 'free', options);

    if (Config.isWriteAllBoard) {
      this.getBoardList();
    } else {
      this.getCategory();
    }

    this.addEvent();

    // parameter & hash Module - page, query, searchType, articleId
    this.paramInfo = new ParamInfo();
    this.paramInfo.setParamByUrl();

    if (Config.isTag) {
      this.tag = new Tag();
      this.tag.initWrite(this.editor);
    }

    // 게시글 수정 모드 체크
    if (this.articleId) {
      this.update();
    } else {
      this.loadedEnd();
    }

    Svg.get();
  }

  public getData() {
    return this.updateData;
  }

  public removeButtonUI() {
    return `<button class="fe-btn ${this.removeButtonName}"><i class="editor-icon-remove"><span hidden="">remove</span></i></button>`;
  }

  public update() {
    const viewUrl = Util.Tmpl.render({
      data: { articleId: this.articleId, board: Config.board },
      template: Config.view
    });

    const viewPromise = Util.get(viewUrl);
    const get$ = Util.from(viewPromise);

    get$.subscribe(
      (data: any) => {
        const _article = Config.isUuid ? data.article.article.contentMeta : data.article;
        const _uid = _article.writer.loginUser.uid;
        const _title = Util.decode(_article.title);
        const _contents = Config.isUuid ? data.article.article.content.content : _article.contents;
        const gameCharacterName = _article.writer.gameUser.gameCharacterName;
        const gameServerId = _article.writer.gameUser.gameServerId;
        const _contentsInfo = {
          title: _title,
          contents: _contents,
          serverMaster: Site.isServerMaster(data.article)
        };
        let _$contents: any;
        this.categoryId = Config.isUuid ? _article.categoryBoard.id : _article.category.categoryId;

        if (Config.guid === _uid || GameInfo.isEqualGameUser(gameCharacterName, gameServerId)) {
          jQuery('#title').val(_title);
          _$contents = jQuery('<div></div>');
          _$contents.append(_contents);
          _$contents.find('img').after(this.removeButtonUI());
          _$contents.find('.fe-video .fe-video-inner iframe').after(this.removeButtonUI());
          _$contents.find('.fe-video, .img').addClass('fr-deletable');
          this.editor.set(_$contents.html());
        }

        if (this.dropdownLayer) {
          this.dropdownLayer.setValue(this.categoryId);
        }

        if (Config.isTag) {
          const _tags = data.tags;
          this.tag.setItems(_tags);
        }

        // set article Info
        this.updateData = data;
        this.onLoaded.emit(_contentsInfo);
      },
      () => {
        this.onLoaded.emit({});
      }
    );
  }

  public setCategoryUI(data: any, categoryDepth: number = 0) {
    if (this.dropdownLayer || this.articleId) {
      this.dropdownLayer.removeEvent();
      this.dropdownLayer = null;
      this.categoryId = 0;
      // return;
    }

    $('.board-write-category')
      .empty()
      .show();

    if (Config.isWriteAllBoard) {
      if (categoryDepth === 2) {
        this.setCategory2depth(data);
      } else if (categoryDepth !== 0) {
        this.setCategory1depth(data);
      }
    } else {
      if (Config.isShowCategory2Depth) {
        this.setCategory2depth(data);
      } else if (Config.isServerBoard || Config.isCategory || Config.isShowCategory) {
        this.setCategory1depth(data);
      }
    }

    if (this.dropdownLayer) {
      this.categoryId = this.dropdownLayer.getValue();
    }

    // 글 수정 시 카테고리 비활성화
    // 옵션 적용 시 카테고리 비활성화
    if (this.dropdownLayer && (this.articleId || Config.isDisabledWriteCategory)) {
      this.disabledSelectBox(this.dropdownLayer.getNode());
    }
  }

  private setCategory2depth(data: any) {
    const tmp = Config.isUuid ? data.tree.root.children : data.categories;
    const _categoryId = this.categoryId || Util.getParams().categoryId;

    this.dropdownLayer = new DropdownLayer2Depth(jQuery('.board-write-category'), tmp, 'boardCategory');

    if (_categoryId) {
      this.dropdownLayer.setValue(_categoryId);
    } else {
      this.dropdownLayer.setTextValue(Config.serverName[GameInfo.getGameServerId()]);
    }

    this.dropdownLayer.addChange(() => {
      this.categoryId = this.dropdownLayer.getValue();
    });
  }

  private setCategory1depth(data: any) {
    const tmp: any = [];
    // let _categoryId = (this.articleId) ? this.categoryId : Util.getParams().categoryId;
    let _categoryId = this.categoryId || Util.getParams().categoryId;

    data = Util.DataFilter.filter(data, Config.isUuid ? { boardActivated: true } : { activated: true });

    data.forEach((item: any) => {
      tmp.push({
        key: Config.isUuid ? item.boardWrapper.board.id : item.categoryId,
        value: Config.isUuid ? item.boardWrapper.board.boardName : item.categoryName
      });
    });

    if (!tmp.length) {
      return;
    }

    this.dropdownLayer = new DropdownLayer(jQuery('.board-write-category'), tmp, 'boardCategory');
    if (!_categoryId || _categoryId === '0' || _categoryId === '') {
      _categoryId = tmp[0].key;
    }

    this.dropdownLayer.setValue(_categoryId);

    this.dropdownLayer.addChange(() => {
      this.categoryId = this.dropdownLayer.getValue();
    });
  }

  // permission List
  public setBoardListUI(data: any) {
    let currentBoard = Config.board;
    let _value = '';

    this.permissionList.push({
      key: 'all',
      value: Config.L10N.chooseBoard,
      depth: 0,
      boardType: 0,
      aliasName: 'all',
      rootCategoryId: ''
    });
    data['boards'].forEach((item: any) => {
      this.permissionList.push({
        key: item.aliasName,
        value: item.boardName,
        depth: item.categoryDepth,
        boardType: item.boardType,
        aliasName: item.aliasName,
        rootCategoryId: item.rootCategoryId
      });
    });

    this.dropdownBoardList = new DropdownLayer(jQuery('.board-write-alias'), this.permissionList, 'boardAlias');

    if (!currentBoard || currentBoard === '0' || currentBoard === '' || currentBoard === 'all') {
      currentBoard = this.permissionList[0].key;
    }
    this.dropdownBoardList.setValue(currentBoard);
    this.boardListChange();

    this.dropdownBoardList.addChange(() => {
      // 서브 카테고리 중복 생성 방지
      if (_value !== this.dropdownBoardList.getValue()) {
        this.boardListChange();
      }
      _value = this.dropdownBoardList.getValue();
    });

    if (this.articleId || Config.isDisabledWriteCategory) {
      this.disabledSelectBox(this.dropdownBoardList.getNode());
    }
  }

  public boardListChange() {
    const win = window as any;
    const setDefaultPath = (path: string) => {
      const reg = new RegExp('api');
      if (reg.test(path)) {
        return '/';
      } else {
        return path || '/';
      }
    };
    let val = this.dropdownBoardList.getValue();
    let list = this.permissionList;

    for (let i = 0; i <= list.length - 1; i++) {
      if (val === list[i].key) {
        this.boardType = list[i].boardType;
        Config.viewPage = `${setDefaultPath(win._path)}board/${list[i].aliasName}/view`;
        if (Config.listPage === 'list') {
          Config.listPage = `${setDefaultPath(win._path)}board/${list[i].aliasName}/list`;
        }

        if (list[i].depth !== 0) {
          this.getCategory(list[i].key, list[i].depth);
        } else {
          this.categoryId = 0;
          this.hideCategory();
        }
        return;
      }
    }
  }

  public hideCategory() {
    $('.board-write-category').hide();
  }

  public getCategory(boardAlias: string = null, categoryDepth: number = 0) {
    if (!Config.isShowWriteCategory && !boardAlias) {
      return;
    }

    let _boardAlias = boardAlias ? boardAlias : Config.board;
    let categoryPromise: any;

    if (Config.isWriteAllBoard) {
      categoryPromise = categoryDepth === 2 ? Util.get(Config.category2depth(_boardAlias), 'GET') : Util.get(Config.category(_boardAlias), 'GET');
    } else {
      categoryPromise = Config.isShowCategory2Depth ? Util.get(Config.category2depth(_boardAlias), 'GET') : Util.get(Config.category(_boardAlias), 'GET');
    }

    // const categoryPromise = ( Config.isShowCategory2Depth || categoryDepth === 2 ) ?
    //     Util.get( Config.category2depth( _boardAlias ), 'GET' ) :
    //     Util.get( Config.category( _boardAlias ), 'GET' );

    const category$ = Util.from(categoryPromise);
    category$.subscribe(
      (data: any) => {
        this.setCategoryUI(data, categoryDepth);
      },
      (data: any) => {
        Config.apiError(data);
      }
    );
  }

  public getBoardList() {
    if (!Config.isWriteAllBoard) {
      return;
    }

    const boardPromise = Util.get(Config.permissions, 'GET');

    const board$ = Util.from(boardPromise);
    board$.subscribe(
      (data: any) => {
        this.setBoardListUI(data);
      },
      (data: any) => {
        Config.apiError(data);
      }
    );
  }

  public createTmpNode(str: string) {
    const _$contents = jQuery('<div></div>');
    return _$contents.append(str);
  }

  public setTemplateByImages(images: any) {
    let _tmp = '';
    for (let idx = 0, len = images.length; len > idx; idx++) {
      const _images = images[idx];
      _tmp += this.editor.imagePlugin.template(_images);
    }

    const _$contents = this.createTmpNode(_tmp);
    _$contents.find(`.${this.removeButtonName}`).remove();
    return _$contents.html();
  }

  private setTagData() {
    const _tags = this.tag.getTags();
    let _data: any = {};

    for (let i = 0; i < _tags.userTags.length; i++) {
      _data[`userTags[${i}]`] = _tags.userTags[i];
    }
    for (let i = 0; i < _tags.plusTags.length; i++) {
      _data[`plusTags[${i}]`] = _tags.plusTags[i];
    }

    return _data;
  }

  public submit(data: any, callback: any) {
    if (!data.title || !jQuery.trim(data.title)) {
      Config.alert(Config.L10N.alert_empty_title);
      this.enableWriteButton();
      return;
    }

    let _contents = data.contents;
    _contents = _contents.replace(/(<([^>]+)>)/gi, '');
    _contents = _contents.replace(/&nbsp;/g, '');
    _contents = _contents.replace(/\s/g, '');

    if (!_contents || this.editor.isEmpty()) {
      Config.alert(Config.L10N.alert_empty_contents);
      this.enableWriteButton();
      return;
    }

    if (Config.isVote) {
      this.editor.voteSubmitBefore(data, (submitData: any) => {
        if (submitData === 'error') {
          this.enableWriteButton();
        } else {
          this.submitBefore(submitData);
        }
      });
    } else {
      this.submitBefore(data);
    }
  }

  public submitBefore(data: any) {
    if (Config.onHookSubmitBefore) {
      Config.onHookSubmitBefore(data);
    } else {
      this.onSubmit(data);
    }
  }

  public onSubmit(data: any, callback?: any) {
    const _addImages = data.addImages;

    if (_addImages && _addImages.length) {
      data.contents += this.setTemplateByImages(_addImages);
      if (!data.thumbnail) {
        data.thumbnail = _addImages[0].fileUrl || _addImages[0].downloadurl || '';
      }
    }

    if (Config.isWriteAllBoard && this.dropdownBoardList) {
      if (this.dropdownBoardList.getValue().toString() === '' || this.dropdownBoardList.getValue().toString() === 'all') {
        Config.alert(Config.L10N.alert_empty_board);
        this.enableWriteButton();
        return;
      }
    }

    // allow write with all category
    if (!Config.allowWriteWithAllCatecory && this.dropdownLayer) {
      const categoryText = this.dropdownLayer.getTextValue();
      const reg = new RegExp(`${Config.L10N.all}`);

      if (reg.test(categoryText)) {
        Config.alert(Config.L10N.alert_allow_write_select_category);
        this.enableWriteButton();
        return;
      }

      if (this.dropdownLayer.getValue().toString() === '0') {
        Config.alert(Config.L10N.alert_allow_write_select_category);
        this.enableWriteButton();
        return;
      }
    }

    if (Config.isWriteAllBoard) {
      if (this.boardType && this.boardType === 3) {
        Config.isImage = true;
      } else {
        Config.isImage = false;
      }
    }

    if (Config.isImage && jQuery(data.contents).find('img').length === 0) {
      Config.alert(Config.L10N.alert_empty_images);
      this.enableWriteButton();
      return;
    }

    // TODO base64 형태 막기
    if (/src=\"data:image\/([a-zA-Z]*);base64,([^\"]*)\"/.test(data.contents)) {
      Config.alert('허용하지 않은 이미지 형식입니다.');
      this.enableWriteButton();
      return;
    }

    const boardName = data.boardAlias ? data.boardAlias : Config.board;
    const submitPromise = !this.articleId
      ? Util.get(Config.write(boardName), 'POST', data)
      : Util.get(
          Config.update({
            board: boardName,
            articleId: this.articleId
          }),
          'PUT',
          data
        );

    const submit$ = Util.from(submitPromise);

    submit$.subscribe(
      (writeData: any) => {
        if (!callback) {
          this.onSubmitAfter(writeData);
        } else {
          this.isSubmit = true;
          callback(writeData);
        }
      },
      (writeData: any) => {
        this.isSubmit = true;
        Config.apiError(writeData);
        this.enableWriteButton();
      }
    );
  }

  public onSubmitAfter(data: any) {
    this.isSubmit = true;
    this.paramInfo.setParam(['page', 1]);
    this.paramInfo.setParam(['searchType', '']);
    const articleId = !Config.isUuid && (data && data.number) ? data.number : Config.isUuid && (data && data.id) ? data.id : this.articleId ? this.articleId : '';
    this.enableWriteButton();

    if (articleId !== '') {
      this.paramInfo.setParam(['articleId', articleId]);
      location.href = Config.viewPage + '?' + this.paramInfo.getParam();
    } else {
      location.href = Config.listPage + '?' + this.paramInfo.getParamIgnore('articleId');
    }
  }

  public gotoList() {
    this.isCancel = true;
    location.href = Config.listPage + '?' + this.paramInfo.getParamIgnore('articleId');
  }

  public reset() {
    this.editor.reset();
  }

  public getThumbnail() {
    const contents = this.editor.getSubmitContents();
    const _$contents = this.createTmpNode(contents);
    let _image =
      _$contents
        .find(`.fe-image-inner img`)
        .not('.fe-emoticon')
        .eq(0)
        .attr('src') || ``;
    let _video = _$contents.find(`.fe-video:eq( 0 )`).attr('data-contents-json') || ``;

    if (_video) {
      _video = JSON.parse(_video).video_id;
      _video = this.setYoutubeThumb(_video);
    }

    if (_image.indexOf('download') !== -1) {
      _image = _image.replace('download', 'download_thumbnail');
    }

    return _image || _video || ``;
  }

  public disabledSelectBox(_node: any) {
    if (!_node) return;
    jQuery(_node)
      .find('.select')
      .addClass('disabled');
    jQuery(_node)
      .find('select')
      .prop('disabled', true);
  }

  public disableWriteButton() {
    jQuery('.boardWriteSubmit').prop('disabled', true);
  }

  public enableWriteButton() {
    jQuery('.boardWriteSubmit').prop('disabled', false);
  }

  public loadedEnd() {
    jQuery(document).ready(() => {
      this.onLoaded.emit();
    });
  }

  public setYoutubeThumb(_video: string) {
    return `https://img.youtube.com/vi/${_video}/0.jpg`;
  }

  private addEvent() {
    if (Config.allowOnBeforeUnloadAlert) {
      jQuery(window).on('beforeunload', () => {
        if (this.isSubmit) {
          return;
        } else if (this.isReload) {
          return;
        } else if (this.isCancel) {
          this.isCancel = false;
          return;
        }
        return Config.L10N.alert_cancel_article;
      });
    }

    jQuery('body').on('click', '.boardWriteSubmit', evt => {
      evt.preventDefault();

      this.disableWriteButton();
      const contents = this.editor.getSubmitContents();
      const _title: any = jQuery('#title').val();

      if (this.editor.isImageUploading()) {
        Config.alert(Config.L10N.alert_valid_upload);
        return;
      }

      if (_title.length < 2) {
        Config.alert(Config.L10N.alert_too_short_title);
        this.enableWriteButton();
        return;
      }

      if (_title.length > 50) {
        Config.alert(Config.L10N.alert_too_long_title);
        this.enableWriteButton();
        return;
      }

      let data: any = {
        token: this.editor.getToken(),
        tokenId: this.editor.getToken(),
        // title: Util.escapeTag( _title ), //should not escape.
        title: _title,
        contents,
        thumbnail: this.getThumbnail(),
        categoryId: this.categoryId
      };

      if (this.articleId) {
        data.articleId = this.articleId;
        data.categoryId = this.categoryId;
      }

      if (this.dropdownLayer && !this.articleId) {
        // data.categoryId = this.categoryId;
        this.paramInfo.setParam(['categoryId', data.categoryId]);
      }

      if (this.dropdownBoardList && !this.articleId) {
        data.boardAlias = this.dropdownBoardList.getValue();
      }

      if (Config.isTag) {
        const _tagCookie = Util.getCookie('TAG_RECOMMAND_DISABLED');
        const _recmdKey = this.tag.getRecmdKey();

        if (_recmdKey !== '') {
          data.recmdKey = _recmdKey;
        }

        if (!this.articleId && !this.tag.isPlusTagAdded && this.tag.getTagLength() === 0 && !_tagCookie && Config.usePlusTag) {
          this.tag
            .getRecmdTags()
            .then((data: any) => this.tag.setRecmdTags(data))
            .then((data: any) => this.tag.setRecmdMarkup(data))
            .then(() => {
              this.tag.isPlusTagAdded = true;
              data = jQuery.extend(data, this.setTagData());
              const _recmdKey = this.tag.getRecmdKey();
              if (_recmdKey !== '') {
                data.recmdKey = _recmdKey;
              }
              this.submit(data, this.onSubmitAfter);
            })
            .catch((err: any) => {
              this.submit(data, this.onSubmitAfter);
            });
        } else {
          data = jQuery.extend(data, this.setTagData());
          this.submit(data, this.onSubmitAfter);
        }
      } else {
        this.submit(data, this.onSubmitAfter);
      }
    });

    jQuery('body').on('click', '.boardWriteCancel', evt => {
      evt.preventDefault();

      if (Config.allowOnBeforeUnloadAlert) {
        Config.confirm(
          Config.L10N.alert_cancel_article,
          () => {
            this.gotoList();
          },
          () => {
            // reject
          }
        );
      } else {
        this.gotoList();
      }
    });
  }

  private template() {
    return `<div class="board-write">
		<form id="boardWriteForm" name="boardWriteForm" action="/board/${Config.board}/article" method="post" autocomplete="off" onSubmit="return false;">
			<input type="hidden" name="articleId" id="articleId" value="${this.articleId}" />
			${Config.isWriteAllBoard ? `<div class="board-write-alias"></div>` : ``}
			<div class="board-write-category" style="display:none;"></div>
			<div class="board-write-title">
				<input type="text" name="title" id="title" maxlength="50" placeholder="${Config.L10N.title}" />
			</div>

			<div id="froala-editor"></div>

			<div class="co-btn-wrap">
				<div class="left">
					<button type="button" class="boardWriteCancel co-btn co-btn-write-cancel"><span>${Config.L10N.btn_cancel}</span></button>
				</div>
				<div class="right">
					<button type="button" class="boardWriteSubmit co-btn co-btn-round co-btn-write-submit"><i class="fe-icon-confirm"></i>${Config.L10N.btn_register}</button>
				</div>
			</div>
		</form>
    </div>`;
  }
}

export default Write;
